module.exports = __webpack_public_path__ + "static/media/sinks.04af35f9.png";